import { combineReducers } from 'redux';
import { claimsReducer } from './claims/reducer';
import { coveragesReducer } from './coverages/reducer';
import { updateDemographicReducer } from './demographics/reducer';
import { dependentEnrollmentsDetailsReducer, dependentCoveragesDetailsReducer } from './dependentDetails/reducer';
import { enrollmentsReducer } from './enrollments/reducer';
import { memberAccountsReducer } from './memberAccounts/reducer';
import { memberVerificationReducer } from './memberVerification/reducer';
import { orderIdCardReducer } from './orderIdCards/reducer';
import { planDetailsReducer } from './planDetails/reducer';
import { PriorAuthReducer } from './priorAuth/reducer';
import { secureMessageReducer } from './securemessage/reducer';
import { sideNavItemReducer } from './sidenavItems/reducer';
import {tenantReducer} from './tenantinfo/reducer';
import {pcpDetailsReducer} from './yourCareTeam/reducer';
import {insuranceReducer} from './insurance/reducer';

const appReducer = combineReducers({
    memberAccounts: memberAccountsReducer,
    memberVerification: memberVerificationReducer,
    tenant: tenantReducer,
    enrollments: enrollmentsReducer,
    coverages: coveragesReducer,
    dependentEnrollments: dependentEnrollmentsDetailsReducer,
    dependentCoverages: dependentCoveragesDetailsReducer,
    planDetails:planDetailsReducer,
    claims:claimsReducer,
    secureMessage: secureMessageReducer,
    orderIdCard: orderIdCardReducer,
    sideNavItem: sideNavItemReducer,
    updateDemographics: updateDemographicReducer,
    pcpDetails: pcpDetailsReducer,
    priorAuth : PriorAuthReducer,
    insurances: insuranceReducer,

});

export default (state, action) => appReducer({ ...state }, action);
